<template>
	<create-edit-layout v-if="showCreateEditAdminClients" element="AdminClients" icon="far fa-id-card" @duplicatecomplete="$emit('duplicatecomplete')">
		<v-col cols="12" xs="12" sm="10">
			<ValidationProvider ref="fullname" vid="fullname" :name="$t('tenant.fullname')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('tenant.fullname')" v-model="currentAdminClients.fullname" :error-messages="errors" :autofocus="$appOptions.canAutofocus()"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="2">
			<ValidationProvider vid="ateco" :name="$t('tenant.ateco')" rules="" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.ateco')" v-model="currentAdminClients.ateco" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="6">
			<ValidationProvider ref="shortname" vid="shortname" :name="$t('tenant.shortname')" rules="max:30" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.shortname')" v-model="currentAdminClients.shortname" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="3">
			<ValidationProvider vid="taxcode" :name="$t('tenant.taxcode')" rules="min:11|max:16" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.taxcode')" v-model="currentAdminClients.taxcode" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="3">
			<ValidationProvider vid="vatid" :name="$t('tenant.vatid')" rules="required|min:11|max:16" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('tenant.vatid')" v-model="currentAdminClients.vatid" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="4">
			<ValidationProvider vid="email" :name="$t('tenant.email')" rules="email|required" v-slot="{ errors, field }">
				<v-text-field type="email" class="required" :label="$t('tenant.email')" v-model="currentAdminClients.email" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="4">
			<ValidationProvider vid="phone" :name="$t('tenant.phone')" rules="" v-slot="{ errors, field }">
				<v-text-field type="tel" :label="$t('tenant.phone')" v-model="currentAdminClients.phone" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="4">
			<ValidationProvider vid="whatsapp" :name="$t('tenant.whatsapp')" rules="" v-slot="{ errors, field }">
				<v-text-field type="tel" :label="$t('tenant.whatsapp')" v-model="currentAdminClients.whatsapp" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="5">
			<ValidationProvider vid="address" :name="$t('tenant.address')" rules="" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.address')" v-model="currentAdminClients.address" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="4">
			<ValidationProvider vid="city" :name="$t('tenant.city')" rules="" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.city')" v-model="currentAdminClients.city" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="2">
			<ValidationProvider vid="state" :name="$t('tenant.state')" rules="" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.state')" v-model="currentAdminClients.state" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="1">
			<ValidationProvider vid="postcode" :name="$t('tenant.postcode')" rules="" v-slot="{ errors, field }">
				<v-text-field type="number" :label="$t('tenant.postcode')" v-model="currentAdminClients.postcode" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="4">
			<ValidationProvider vid="website" :name="$t('tenant.website')" rules="" v-slot="{ errors, field }">
				<v-text-field :label="$t('tenant.website')" v-model="currentAdminClients.website" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<ValidationProvider vid="redditivity" :name="$t('tenant.redditivity')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" type="number" :label="$t('tenant.redditivity')" v-model="currentAdminClients.redditivity" :error-messages="errors" suffix="%" v-mask="'##'"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="2">
			<date-field vid="vat_year" :name="$t('tenant.vat_year')" rules="date_format" v-model="currentAdminClients.vat_year"></date-field>
		</v-col>
		<v-col cols="12" xs="12" sm="3">
			<v-checkbox hide-details :label="$t('tenant.force_aliquota_15')" v-model="currentAdminClients.force_aliquota_15">
				<info-box slot="prepend" :title="$t('tenant.force_aliquota_15')" :message="$t('tenant.force_aliquota_15_description')"></info-box>
			</v-checkbox>
		</v-col>
	</create-edit-layout>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		currentAdminClients: {
			get: function () {
				return this.$store.getters.getCurrentAdminClients;
			},
			set: function (value) {
				this.$store.commit("setCurrentAdminClients", value);
			},
		},
		showCreateEditAdminClients() {
			return this.$store.getters.showCreateEditAdminClients;
		},
	},
};
</script>
